/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAccessCatalog } from '../models/api-response-access-catalog';
import { ApiResponseListAgentGroup } from '../models/api-response-list-agent-group';
import { ApiResponseListAgentGroupMemberCandidate } from '../models/api-response-list-agent-group-member-candidate';
import { ApiResponseString } from '../models/api-response-string';
import { getAccessCatalog } from '../fn/access-management-api/get-access-catalog';
import { GetAccessCatalog$Params } from '../fn/access-management-api/get-access-catalog';
import { getAssignableGroups } from '../fn/access-management-api/get-assignable-groups';
import { GetAssignableGroups$Params } from '../fn/access-management-api/get-assignable-groups';
import { getCurrentUserGroup } from '../fn/access-management-api/get-current-user-group';
import { GetCurrentUserGroup$Params } from '../fn/access-management-api/get-current-user-group';
import { getMemberCandidates } from '../fn/access-management-api/get-member-candidates';
import { GetMemberCandidates$Params } from '../fn/access-management-api/get-member-candidates';

@Injectable({ providedIn: 'root' })
export class AccessManagementApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAssignableGroups()` */
  static readonly GetAssignableGroupsPath = '/v1/api/ui/agent-groups/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAssignableGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssignableGroups$Response(params?: GetAssignableGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentGroup>> {
    return getAssignableGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAssignableGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAssignableGroups(params?: GetAssignableGroups$Params, context?: HttpContext): Observable<ApiResponseListAgentGroup> {
    return this.getAssignableGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgentGroup>): ApiResponseListAgentGroup => r.body)
    );
  }

  /** Path part for operation `getMemberCandidates()` */
  static readonly GetMemberCandidatesPath = '/v1/api/ui/agent-groups/member-candidates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMemberCandidates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMemberCandidates$Response(params?: GetMemberCandidates$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentGroupMemberCandidate>> {
    return getMemberCandidates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMemberCandidates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMemberCandidates(params?: GetMemberCandidates$Params, context?: HttpContext): Observable<ApiResponseListAgentGroupMemberCandidate> {
    return this.getMemberCandidates$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgentGroupMemberCandidate>): ApiResponseListAgentGroupMemberCandidate => r.body)
    );
  }

  /** Path part for operation `getCurrentUserGroup()` */
  static readonly GetCurrentUserGroupPath = '/v1/api/ui/agent-groups/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUserGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUserGroup$Response(params?: GetCurrentUserGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return getCurrentUserGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUserGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUserGroup(params?: GetCurrentUserGroup$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.getCurrentUserGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `getAccessCatalog()` */
  static readonly GetAccessCatalogPath = '/v1/api/ui/access-catalog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAccessCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessCatalog$Response(params?: GetAccessCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAccessCatalog>> {
    return getAccessCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAccessCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAccessCatalog(params?: GetAccessCatalog$Params, context?: HttpContext): Observable<ApiResponseAccessCatalog> {
    return this.getAccessCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAccessCatalog>): ApiResponseAccessCatalog => r.body)
    );
  }

}
